// This file was automatically generated from notification.schema.d.ts
// and contains types and methods for calling PIE

import * as PIEBridge from '@microsoft/pie.sharedbridge';

export function GetPIEScriptVersion(): number {
    return 0.1;
}

export enum UserAction {
    Dismiss = 'Dismiss',
    Snooze = 'Snooze',
}

export interface ReminderNotificationData {
    subject: string;
    startTime: Date;
    endTime: Date;
    location: string;
    itemId: string;
}

export class JsonPostProcessing {
    public static UserActionValue(json: string): UserAction {
        return json as UserAction;
    }

    public static ReminderNotificationDataValue(json: any): ReminderNotificationData {
        const value = json as ReminderNotificationData;
        value.startTime = new Date(value.startTime);
        value.endTime = new Date(value.endTime);
        return value;
    }
}

export async function eventReminderNotification(context: ReminderNotificationData): Promise<void> {
    return PIEBridge.HostBridge.invokeHost(
        'Notification.eventReminderNotification',
        context,
        undefined
    );
}

// Registers for the specified event
export function registerForUserActionOnNotification(
    callback: (action: UserAction) => void
): PIEBridge.DisposeEventRegistration {
    let callbackHandler: (jsonObject: any) => void = function (jsonObject: any) {
        if (jsonObject) {
            const eventArgs: UserAction = JsonPostProcessing.UserActionValue(jsonObject);
            callback(eventArgs);
        }
    };

    return PIEBridge.HostBridge.registerForEvent(
        'Notification.userActionOnNotification',
        callbackHandler
    );
}
